angular.module('ArticlesApp').run(["$rootScope", "ArticleUtilsService",
	function ($rootScope, ArticleUtilsService) {
        $rootScope.permissionToAddEdit = ArticleUtilsService.ArticleHelpers().checkGlobalEditPermission();
        $rootScope.permissionForTrial = ArticleUtilsService.ArticleHelpers().checkGlobalTrialPermission();
        $rootScope.in_app_add_button = '/static/assets/khapps/articles/includes/articles_navbar_add_button.html';
        $rootScope.in_app_links_template = '/static/assets/khapps/articles/includes/articles_navbar_links.html';
        $rootScope.select_filters_template = "/static/assets/khapps/articles/includes/articles_navbar_filters.html";
    }]);